@if (isLoading) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
@if (infringement) {
  <div>
    <!-- Common fields -->
    @if (infringement.infringementType.toString() === '1') {
      <app-infringement-details-contract-breach [infringement]="infringement" (refreshData)="refreshDataMethod()">
      </app-infringement-details-contract-breach>
    } @else if (infringement.infringementType === 0) {
      <app-infringement-details-contract-breach [infringement]="infringement" (refreshData)="refreshDataMethod()">
      </app-infringement-details-contract-breach>
    }
  </div>
}
